import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage'
import enviroment from '../enviroment';

const fireApp = initializeApp(enviroment.firebaseConfig);
const auth = getAuth(fireApp);
const db = getFirestore(fireApp);
const storage = getStorage(fireApp);
const fireAuth = auth;

export { fireApp, auth, db, fireAuth, storage };